import type { ProcessStep } from '../domain/landing.types'

type ProcessSectionProps = { items: ProcessStep[] }

export function ProcessSection({ items }: ProcessSectionProps) {
  return (
    <section className="section process-section" aria-labelledby="process-title">
      <div className="section-heading" id="como-trabajamos">
        <p>CÓMO TRABAJAMOS</p>
        <h2 id="process-title">Un proceso claro. Una experiencia sin rodeos.</h2>
      </div>
      <div className="process-grid">
        {items.map((item) => (
          <article className="process-card" key={item.order}>
            <span className="process-card__number">0{item.order}</span>
            <h3>{item.title}</h3>
            <p>{item.description}</p>
          </article>
        ))}
      </div>
    </section>
  )
}
